<template>
	<el-dialog :visible.sync="dlgVisible" center title="提示" width="60%">
		<avue-crud :data="dataEmployeeRepeat" :option="optionEmployeeRepeat">
			<template slot="menuLeft">
				<div>
					本次投保的生效日期：
					<span style="font-weight: bold; color: red">{{ effectiveDate }}</span>
				</div>
				<div>
					以下投保人员的保单在
					<span>{{ effectiveDate }}</span>
					零时还未到期，请在本次“投保人员清单”中删除这些人员
				</div>
			</template>
		</avue-crud>
		<!-- <template slot="effectiveDateEarliest" slot-scope="scope">
        <span>{{getNextDay(scope.row.expiryDate)}}</span>
    </template>           -->
		<span slot="footer" class="dialog-footer">
			<el-button size="medium" @click="dlgVisible = false">我已知晓</el-button>
			<el-button size="medium" type="primary" @click="removeRepeatEmps">删除重复人员</el-button>
		</span>
	</el-dialog>
</template>

<script>
import {optionEmployeeRepeat} from '@/const/crud/insurance/policy'

export default {
	name: 'RepeatEmpsDlg',
	data: function () {
		return {
			dlgVisible: false,
			optionEmployeeRepeat: this.deepClone(optionEmployeeRepeat),
			dataEmployeeRepeat: [],
			effectiveDate: '',
		}
	},
	methods: {
		setRepeatEmps(effectiveDate, emps) {
			this.dataEmployeeRepeat = emps || []
			this.dataEmployeeRepeat.forEach((item) => {
				item.effectiveDateEarliest = this.getNextDay(item.expiryDate)
			})
			this.effectiveDate = effectiveDate
			this.dlgVisible = true
		},
		removeRepeatEmps() {
			this.$emit('removeRepeatEmps', this.dataEmployeeRepeat)
			this.dlgVisible = false
		},
		getNextDay(dayStr) {
			let day = new Date(dayStr)
			day.setDate(day.getDate() + 1)
			let y = day.getFullYear()
			let m = day.getMonth() + 1
			let d = day.getDate()
			return y + '-' + m + '-' + d
		},
	},
}
</script>
